import {originString, string} from 'common/yup';
import {CONTEXT_SEND_PARAMETER} from '../constants';

export const passphrase = () =>
   string().when(CONTEXT_SEND_PARAMETER, {
      is: true,
      then: originString()
         .nullable()
         .transform(function (val) {
            const isEmptyString = val === '';
            if (isEmptyString || val?.replace(/\*/g, '').length > 0) {
               return val;
            }
            return null;
         }),
   });
